/*
OBJECT MUST FOLLOW THIS FORMAT!

  {
    column: column name in form response database,
    name: Title of watcher,
    values: [ value must be according to form response model enum ]
  },

  model enum values better to consist of words from the column name,
  JS humanize will strip similar values to be more readable
*/


export default [
  {
    column: "atr_duration",
    name: "ATR Duration",
    values: ["ATR_duration_prevailing", "ATR_duration_increase_rate"],
  },
  {
    column: "atp_earnest_deposit_to",
    name: "Pay ATP Earnest Deposit To",
    values: [
      "ATP_earnest_deposit_to_vendor_personal",
      "ATP_earnest_deposit_to_vendor_company",
      "ATP_earnest_deposit_to_SHIJIE",
      "ATP_earnest_deposit_to_vendor_lawyer",
      "ATP_earnest_deposit_to_purchaser_lawyer",
    ],
  },
  {
    column: "atr_earnest_deposit_to",
    name: "Pay ATR Earnest Deposit To",
    values: [
      "ATR_earnest_deposit_to_SHIJIE",
      "ATR_earnest_deposit_to_landlord_personal",
      "ATR_earnest_deposit_to_landlord_company",
      "ATR_earnest_deposit_to_landlord_lawyer",
      "ATR_earnest_deposit_to_tenant_lawyer"
    ],
  },
  {
    column: "purchaser_company_type",
    name: "Purchaser Company Type",
    values: [
      "purchaser_company_type_Personal",
      "purchaser_company_type_Sdn_Bhd",
    ],
  },
  {
    column: "purchaser_company_type_2",
    name: "Purchaser Company Type 2",
    values: [
      "purchaser_company_type_2_None",
      "purchaser_company_type_2_Personal",
      "purchaser_company_type_2_Sdn_Bhd",
    ],
  },
  {
    column: "purchaser_company_type_3",
    name: "Purchaser Company Type 3",
    values: [
      "purchaser_company_type_3_None",
      "purchaser_company_type_3_Personal",
      "purchaser_company_type_3_Sdn_Bhd",
    ],
  },
  {
    column: "purchaser_sst",
    name: "Purchaser SST",
    values: ["excluding_purchaser_SST", "including_purchaser_SST"],
  },
  {
    column: "landlord_company_type",
    name: "Landlord Company Type",
    values: [
      "landlord_company_type_Personal",
      // "landlord_company_type_Enterprise",
      "landlord_company_type_Sdn_Bhd",
    ],
  },
  {
    column: "landlord_company_type_2",
    name: "Landlord Company Type 2",
    values: [
      "landlord_company_type_2_None",
      "landlord_company_type_2_Personal",
      // "landlord_company_type_2_Enterprise",
      "landlord_company_type_2_Sdn_Bhd",
    ],
  },
  {
    column: "landlord_company_type_3",
    name: "Landlord Company Type 3",
    values: [
      "landlord_company_type_3_None",
      "landlord_company_type_3_Personal",
      // "landlord_company_type_3_Enterprise",
      "landlord_company_type_3_Sdn_Bhd",
    ],
  },
  {
    column: "landlord_agency_fee_sst",
    name: "Landlord Agency Fee SST",
    values: [
      "excluding_landlord_agency_fee_SST",
      "including_landlord_agency_fee_SST",
    ],
  },
  {
    column: "landlord_ta_sst",
    name: "Landlord TA SST",
    values: ["excluding_landlord_TA_SST", "including_landlord_TA_SST"],
  },
  {
    column: "tenant_company_type",
    name: "Tenant Company Type",
    values: [
      "tenant_company_type_Personal",
      "tenant_company_type_Enterprise",
      "tenant_company_type_Sdn_Bhd",
    ],
  },
  {
    column: "tenant_company_type_2",
    name: "Tenant Company Type 2",
    values: [
      "tenant_company_type_2_None",
      "tenant_company_type_2_Personal",
      "tenant_company_type_2_Enterprise",
      "tenant_company_type_2_Sdn_Bhd",
    ],
  },
  {
    column: "tenant_company_type_3",
    name: "Tenant Company Type 3",
    values: [
      "tenant_company_type_3_None",
      "tenant_company_type_3_Personal",
      "tenant_company_type_3_Enterprise",
      "tenant_company_type_3_Sdn_Bhd",
    ],
  },
  {
    column: "tenant_agreed_disbursement_sst",
    name: "Tenant Agreed Disbursement SST",
    values: [
      'excluding_tenant_tenant_agreed_disbursement_SST',
      'including_tenant_tenant_agreed_disbursement_SST',
    ],
  },
  {
    column: "tenant_ta_sst",
    name: "Tenant TA SST",
    values: ["excluding_tenant_TA_SST", "including_tenant_TA_SST"],
  },
  {
    column: "termination_clause",
    name: "Termination Clause",
    values: [
      "termination_clause_Or",
      "termination_clause_Plus",
      "termination_clause_Firm",
    ],
  },
  {
    column: "renew_clause",
    name: "Renew Clause",
    values: [
      "renew_clause_market_rate",
      "renew_clause_agreed_upon",
      "renew_clause_increment",
      "renew_clause_none",
    ],
  },
  {
    column: "transacted_price_consent",
    name: "Transacted Price Consent",
    values: [
      "with_transacted_price_consent",
      "without_transacted_price_consent",
    ],
  },
  {
    column: "landlord_sign_as",
    name: "Landlord Sign As",
    values: [
      "landlord_sign_as_company",
      "landlord_sign_as_personal",
    ],
  },
  {
    column: "tenant_sign_as",
    name: "Tenant Sign As",
    values: [
      "tenant_sign_as_company",
      "tenant_sign_as_personal",
    ],
  },
  {
    column: "vendor_company_type",
    name: "Vendor Company Type",
    values: [
      "vendor_company_type_Personal",
      "vendor_company_type_Sdn_Bhd",
    ],
  },
  {
    column: "vendor_company_type_2",
    name: "Vendor Company Type 2",
    values: [
      "vendor_company_type_2_None",
      "vendor_company_type_2_Personal",
      "vendor_company_type_2_Sdn_Bhd",
    ],
  },
  {
    column: "vendor_company_type_3",
    name: "Vendor Company Type 3",
    values: [
      "vendor_company_type_3_None",
      "vendor_company_type_3_Personal",
      "vendor_company_type_3_Sdn_Bhd",
    ],
  },
  {
    column: "vacant_possession",
    name: "Vacant Possession",
    values: ["with_vacant_possession", "without_vacant_possession"],
  },
  {
    column: "vendor_sst",
    name: "Vendor SST",
    values: ["excluding_vendor_SST", "including_vendor_SST"],
  },
  {
    column: "co_agreement_terms",
    name: "Co_Agreement Terms",
    values: ["share", "collect_own"]
  },
  {
    column: "deposit_payment_method",
    name: "Deposit Payment Method",
    values: ["deposit_payment_method_online_transfer_/_cheque", "deposit_payment_method_online_transfer", "deposit_payment_method_cheque", "deposit_payment_method_cash"],
  },
  {
    column: "purchaser_or_tenant",
    name: "Purchaser or Tenant",
    values: ["purchaser_or_tenant_purchaser", "purchaser_or_tenant_tenant"]
  },
  {
    column: "penang_termination_option",
    name: "Penang Termination Option",
    values: ["penang_termination_option_expatriate_clause", "penang_termination_option_either_party", "penang_termination_option_notice_by_tenant_only", "penang_termination_option_firm_tenancy", "penang_termination_option_early_termination_2mths_forfeited", "penang_termination_option_early_termination_pay_the_unexpired_portion_rental", "penang_termination_option_early_termination_by_tenant/landlord_2mths"]
  },
  {
    column: "penang_option_renew",
    name: "Penang Renew Option",
    values: ["penang_option_renew_yes", "penang_option_renew_no"]
  },
  {
    column: "rent_free_period",
    name: "Rent Free Period",
    values: [
      "rent_free_period_N/A",
      "rent_free_period_Yes",
    ],
  },
]